import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: `${API_URL}/api/pl`,
  headers: { 'Content-Type': 'application/json' },
});

// Intercepteur : token JWT unique (plus de double auth)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('finance_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('finance_token');
      localStorage.removeItem('finance_user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

const plApi = {
  // Societes
  getSocietes: () => api.get('/societes'),
  createSociete: (data) => api.post('/societes', data),
  updateSociete: (id, data) => api.put(`/societes/${id}`, data),
  deleteSociete: (id) => api.delete(`/societes/${id}`),

  // Activites
  getActivites: () => api.get('/activites'),
  createActivite: (data) => api.post('/activites', data),
  updateActivite: (id, data) => api.put(`/activites/${id}`, data),
  deleteActivite: (id) => api.delete(`/activites/${id}`),

  // Postes
  getPostes: () => api.get('/postes'),
  createPoste: (data) => api.post('/postes', data),
  deletePoste: (id) => api.delete(`/postes/${id}`),

  // Services
  getGroupes: () => api.get('/groupes'),
  createGroupe: (data) => api.post('/groupes', data),
  updateGroupe: (id, data) => api.put(`/groupes/${id}`, data),
  deleteGroupe: (id) => api.delete(`/groupes/${id}`),
  getEtablissements: () => api.get('/etablissements'),
  saveEtablissement: (code, data) => api.put(`/etablissements/${encodeURIComponent(code)}`, data),
  getServices: () => api.get('/services'),
  createService: (data) => api.post('/services', data),
  updateService: (id, data) => api.put(`/services/${id}`, data),
  deleteService: (id) => api.delete(`/services/${id}`),

  // Exercices
  getExercices: () => api.get('/exercices'),
  createExercice: (data) => api.post('/exercices', data),

  // Plan de comptes
  getPlanComptes: () => api.get('/plan-comptes'),
  createCompte: (data) => api.post('/plan-comptes', data),
  updateCompte: (id, data) => api.put(`/plan-comptes/${id}`, data),
  deleteCompte: (id) => api.delete(`/plan-comptes/${id}`),
  reorderComptes: (items) => api.put('/plan-comptes/reorder/batch', { items }),

  // Budget
  getBudget: (params) => api.get('/budget', { params }),
  saveBudget: (data) => api.put('/budget', data),

  // Ecritures
  getEcritures: (params) => api.get('/ecritures', { params }),
  createEcriture: (data) => api.post('/ecritures', data),

  // Provisions
  getProvisions: (params) => api.get('/provisions', { params }),
  saveProvision: (data) => api.put('/provisions', data),
  deleteProvision: (id) => api.delete(`/provisions/${id}`),
  validerProvision: (id) => api.put(`/provisions/${id}/valider`),

  // Reporting
  getReporting: (params) => api.get('/reporting', { params }),
  getDetailFournisseurs: (params) => api.get('/detail-fournisseurs', { params }),
};

export default plApi;
